"use client";

import { c as _c } from "react/compiler-runtime";
import { ExclamationCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogOverlay, DialogPortal, DialogTitle } from "@/components/ui/dialog";
import { Drawer, DrawerContent, DrawerHeader } from "@/components/ui/drawer";
import { useIsMobile } from "@/hooks/use-mobile";
import type { CheckoutAddressFormData } from "@/modules/checkout/types";
const dinProBold = "font-['DINPro-Bold']";
const dinProRegular = "font-['DINPro-Regular']";

// 地址校验结果接口 - 更新为与新的AddressValidationResult一致
export interface AddressValidationResult {
  isValid: boolean;
  issueKeys: string[]; // 改为issueKeys
  suggestedAddress?: CheckoutAddressFormData;
  rawResponse?: unknown;
}
interface AddressModificationDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  addressData: CheckoutAddressFormData;
  validationResult: AddressValidationResult;
  onConfirm: () => void;
  onBackToEdit: () => void;
}
export function AddressModificationDialog(t0) {
  const $ = _c(35);
  const {
    isOpen,
    onOpenChange,
    addressData,
    validationResult,
    onConfirm,
    onBackToEdit
  } = t0;
  const isMobile = useIsMobile();
  const {
    t
  } = useTranslation();
  if (!addressData || !validationResult) {
    return null;
  }
  const formatAddressForDisplay = _temp;
  if (validationResult.isValid) {
    onConfirm();
    onOpenChange(false);
    return null;
  }
  let t1;
  if ($[0] !== addressData || $[1] !== onBackToEdit || $[2] !== onConfirm || $[3] !== t || $[4] !== validationResult.issueKeys) {
    t1 = () => <div className="p-8"><p className={`${dinProRegular} mb-6 text-sm leading-relaxed text-black`}>{t("order.addressValidation.failureMessage")}</p><div className="mb-6"><div className="border border-gray-300 bg-white p-3"><div className={`${dinProRegular} mb-2 block text-sm font-medium text-black`}>{t("order.addressValidation.youEntered")}</div><p className={`${dinProRegular} text-sm text-black`}>{formatAddressForDisplay(addressData)}</p></div></div>{validationResult.issueKeys && validationResult.issueKeys.length > 0 && <div className="mb-6"><div className={`${dinProRegular} mb-2 block text-sm font-medium text-black`}>{t("order.addressValidation.verificationIssue")}</div><div className="border border-amber-200 bg-amber-50 p-3"><div className="flex items-center gap-2"><div className="flex-shrink-0"><ExclamationCircleIcon className="h-5 w-5 text-amber-500" /></div><p className={`${dinProRegular} text-sm text-amber-800`}>{t(validationResult.issueKeys[0])}</p></div></div></div>}<div className="space-y-3"><Button onClick={e => {
          e.stopPropagation();
          onBackToEdit();
        }} className={`${dinProBold} h-12 w-full rounded-none bg-black text-sm font-bold text-white hover:bg-gray-800`}>{t("order.addressValidation.backToEdit")}</Button><Button onClick={onConfirm} variant="outline" className={`${dinProBold} h-12 w-full rounded-none border-black text-sm font-bold text-black hover:bg-gray-50`}>{t("order.addressValidation.useEntered")}</Button></div></div>;
    $[0] = addressData;
    $[1] = onBackToEdit;
    $[2] = onConfirm;
    $[3] = t;
    $[4] = validationResult.issueKeys;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const renderFailureContent = t1;
  if (isMobile) {
    let t2;
    if ($[6] !== t) {
      t2 = t("order.addressValidation.title");
      $[6] = t;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    let t3;
    if ($[8] !== t2) {
      t3 = <h3 className={`${dinProBold} text-lg font-bold text-black`}>{t2}</h3>;
      $[8] = t2;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    let t4;
    if ($[10] !== onOpenChange) {
      t4 = e_0 => {
        e_0.stopPropagation();
        onOpenChange(false);
      };
      $[10] = onOpenChange;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    let t5;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <XMarkIcon className="h-5 w-5 text-gray-500" />;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    let t6;
    if ($[13] !== t4) {
      t6 = <Button variant="ghost" size="sm" onClick={t4} className="h-8 w-8 p-0 hover:bg-gray-100">{t5}</Button>;
      $[13] = t4;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    let t7;
    if ($[15] !== t3 || $[16] !== t6) {
      t7 = <DrawerHeader className="border-b bg-white p-4 text-left"><div className="flex items-center justify-between">{t3}{t6}</div></DrawerHeader>;
      $[15] = t3;
      $[16] = t6;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    let t8;
    if ($[18] !== renderFailureContent) {
      t8 = <div className="bg-white">{renderFailureContent()}</div>;
      $[18] = renderFailureContent;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    let t9;
    if ($[20] !== t7 || $[21] !== t8) {
      t9 = <DrawerContent className="address-validation-drawer h-auto">{t7}{t8}</DrawerContent>;
      $[20] = t7;
      $[21] = t8;
      $[22] = t9;
    } else {
      t9 = $[22];
    }
    let t10;
    if ($[23] !== isOpen || $[24] !== onOpenChange || $[25] !== t9) {
      t10 = <Drawer open={isOpen} onOpenChange={onOpenChange} direction="bottom" shouldScaleBackground={false} dismissible={false}>{t9}</Drawer>;
      $[23] = isOpen;
      $[24] = onOpenChange;
      $[25] = t9;
      $[26] = t10;
    } else {
      t10 = $[26];
    }
    return t10;
  }
  let t2;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DialogOverlay className="z-[9999]" />;
    $[27] = t2;
  } else {
    t2 = $[27];
  }
  let t3;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DialogTitle className="sr-only" />;
    $[28] = t3;
  } else {
    t3 = $[28];
  }
  let t4;
  if ($[29] !== renderFailureContent) {
    t4 = <DialogPortal>{t2}<DialogContent className="address-validation-dialog !w-[500px] !max-w-[500px] bg-white p-0 z-[10000]" onPointerDownOutside={_temp2} onEscapeKeyDown={_temp3} onInteractOutside={_temp4}>{t3}<div className="relative">{renderFailureContent()}</div></DialogContent></DialogPortal>;
    $[29] = renderFailureContent;
    $[30] = t4;
  } else {
    t4 = $[30];
  }
  let t5;
  if ($[31] !== isOpen || $[32] !== onOpenChange || $[33] !== t4) {
    t5 = <Dialog open={isOpen} onOpenChange={onOpenChange} modal={true}>{t4}</Dialog>;
    $[31] = isOpen;
    $[32] = onOpenChange;
    $[33] = t4;
    $[34] = t5;
  } else {
    t5 = $[34];
  }
  return t5;
}
function _temp4(e_3) {
  return e_3.preventDefault();
}
function _temp3(e_2) {
  return e_2.preventDefault();
}
function _temp2(e_1) {
  return e_1.preventDefault();
}
function _temp(address) {
  if (!address) {
    return "";
  }
  const parts = [address.address, address.addressDetail, address.city, address.province, address.zipCode].filter(Boolean);
  return parts.join(" ");
}